import type {FeatureResponseBody, FeatureWriteRequestBody} from '@dms/api/new-vehicle';

/** What an earlier try of the same package save left on a feature. */
type FeatureCheckpoint = {standaloneOrderable: boolean; version: number};

/**
 * The library taxonomy writes of a package save: one feature write per member whose "orderable
 * alone" differs from the wanted value. Every other field keeps its stored value, as a batch refuses
 * any other change of the feature (`featureFieldChanged`). The single save and the grouped save both
 * send these writes, so a group changes no more than the single save does (Q8).
 */
export const featureTaxonomyUpdates = (
  features: FeatureResponseBody[],
  values: {memberFeatureIds: string[]; packageOnlyFeatureIds: string[]},
  checkpointOf: (featureId: string) => FeatureCheckpoint | undefined = () => undefined
) =>
  features.flatMap((feature) => {
    const standaloneOrderable = !values.packageOnlyFeatureIds.includes(feature.id);
    const checkpoint = checkpointOf(feature.id);
    if (
      !values.memberFeatureIds.includes(feature.id) ||
      (checkpoint?.standaloneOrderable ?? feature.standaloneOrderable) === standaloneOrderable
    ) {
      return [];
    }
    const featureWriteRequestBody: FeatureWriteRequestBody = {
      name: feature.name,
      codes: feature.codes,
      kind: feature.kind,
      fitStage: feature.fitStage,
      standaloneOrderable,
      category: feature.category,
      factoryCode: feature.factoryCode,
      version: checkpoint?.version ?? feature.version,
    };
    return [{featureId: feature.id, featureWriteRequestBody}];
  });
